import { FilterableTableInvoices } from "../../../components/TableInvoices/FilterableTableInvoices";

export const RouteIndex: React.FC = () => (
  <FilterableTableInvoices
    showDownloadCsv
    emptyState={{
      firstTime: "Invoices you create will show up here.",
      standart: "No invoices."
    }}
  />
);
